import { useVoiceContext } from '../contexts/VoiceContext';

export function useVoice() {
  return useVoiceContext();
}
